var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.77269 0.655652C6.68645 -0.288524 8.22004 -0.184601 9.19305 0.785008C10.1883 1.77637 10.2963 3.36913 9.32884 4.29747L4.42401 9.00318C4.38302 9.0505 4.32833 9.0849 4.2666 9.10099L0.903667 9.97757C0.631212 10.049 0.375997 9.9414 0.21445 9.77613C0.0528871 9.61083 -0.0479469 9.35478 0.023144 9.08519L0.904315 5.75803C0.916591 5.7024 0.944023 5.65033 0.9848 5.60815L5.77269 0.655652ZM1.4162 6.26634L0.627449 9.24454C0.627438 9.24457 0.627459 9.2445 0.627449 9.24454C0.621733 9.26641 0.626304 9.3034 0.661378 9.33928C0.696533 9.37525 0.72933 9.37719 0.745268 9.37301L3.74662 8.59069C3.70752 8.51311 3.66116 8.425 3.60788 8.32995C3.41484 7.98558 3.13783 7.56279 2.79372 7.21945C2.44954 6.87604 2.02558 6.59929 1.68019 6.40631C1.58385 6.35248 1.49461 6.30572 1.4162 6.26634ZM4.28779 8.26779L8.89614 3.84653C9.56466 3.20505 9.54638 2.01902 8.75196 1.22775C7.9794 0.457891 6.84967 0.441482 6.22178 1.09027L1.73867 5.72752C1.81388 5.76577 1.89679 5.80957 1.98508 5.85874C2.35623 6.06544 2.83517 6.37408 3.23639 6.77358C3.63771 7.17318 3.94762 7.65045 4.15514 8.02038C4.2049 8.10908 4.24918 8.19234 4.28779 8.26779Z",
    fill: "#103046"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPencil);
export default __webpack_public_path__ + "static/media/edit-pencil.a095cb475447e86152bc5e83f79c609b.svg";
export { ForwardRef as ReactComponent };